<template>
  <b-overlay
    :show="isLoading"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>

    <b-card no-body>
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <b-form-group class="mr-1 mb-md-0">
            <CreateModal @submit="upsertPromotion" />
          </b-form-group>

          <b-form-group
            label="Filter"
            label-cols-sm="2"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-card-body>

      <b-table-simple
        striped
        hover
        responsive
        class="position-relative items-center"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <b-thead>
          <b-tr>
            <b-th>โปรโมชั่น</b-th>
            <b-th class="d-none d-md-table-cell">
              รายละเอียด
            </b-th>
            <b-th>เปิด/ปิด</b-th>
            <b-th>Actions</b-th>
          </b-tr>
        </b-thead>

        <draggable
          v-model="items"
          tag="tbody"
          @start="drag = true"
          @end="dragend"
        >
          <b-tr
            v-for="row in items"
            :key="row.id"
          >
            <b-td class="text-truncate">
              {{ row.name }}
            </b-td>
            <b-td class="d-none d-md-table-cell">
              {{ row.description }}
            </b-td>

            <b-td>
              <div class="text-nowrap">
                <b-form-checkbox
                  v-model="row.status"
                  :value="1"
                  :unchecked-value="0"
                  class="custom-control-primary"
                  switch
                  @change="switchEnable(row.id, row.status)"
                />

              </div>
            </b-td>

            <b-td>
              <b-dropdown
                id="dropdown-3"
                text="Success"
                size="sm"
                variant="success"
              >
                <template #button-content>
                  <i class="far fa-edit mr-50" /> จัดการ
                </template>
                <b-dropdown-item @click="edit(row)">
                  <i class="fas fa-pencil mr-1 text-info" /> แก้ไข
                </b-dropdown-item>
                <b-dropdown-item @click="deleteData(row.id)">
                  <i class="fas fa-trash mr-1 text-danger" /> ลบ
                </b-dropdown-item>
              </b-dropdown>
            </b-td>
          </b-tr>
        </draggable>
      </b-table-simple>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- pagination / perPage ถูกคอมเมนต์ไว้เหมือนเดิม -->
      </b-card-body>

      <EditModal
        :edit-modal="editModal"
        :form="form"
        @submit="upsertPromotion"
        @setModal="editModal = $event"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BIconController, BTableSimple, BThead, BTbody, BTr, BTh, BTd, BOverlay,
  BDropdownItem, BDropdown, BModal, BCard, BTable, BAvatar, BFormGroup,
  BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend,
  BButton, BCardBody, VBToggle, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import CreateModal from './create-modal.vue'
import EditModal from './edit-modal.vue'

// ---------- helpers ----------
const toCSV = val => {
  if (Array.isArray(val)) {
    return val.filter(Boolean).map(s => String(s).trim().toUpperCase()).join(',')
  }
  if (!val) return ''
  return String(val).split(',').map(s => s.trim().toUpperCase()).filter(Boolean)
    .join(',')
}
const isFileLike = f => f && (f instanceof File || f instanceof Blob)

export default {
  name: 'PartnerPromotionIndex',

  components: {
    BIconController,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BOverlay,
    BDropdownItem,
    BDropdown,
    BModal,
    BCard,
    BTable,
    BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BFormCheckbox,
    CreateModal,
    EditModal,
    draggable,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },

  data() {
    return {
      UserData: JSON.parse(localStorage.getItem('userData')),
      checked: false,
      depositdata: [],
      DataEditID: '',
      name: '',
      detail: '',
      editModal: false,
      turn: '',
      optionsMember: '',
      isLoading: false,
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      usersList: [],
      datasidebar: [],
      infoModal: { id: 'info-modal', title: '', content: '' },
      form: {},
      fields: [
        { key: 'name', label: 'โปรโมชั่น' },
        { key: 'description', label: 'รายละเอียด' },
        { key: 'enable', label: 'เปิด/ปิด' },
        { key: 'actions', label: 'Actions' },
      ],
      items: [],
      addNewDataSidebar: false,
    }
  },

  computed: {
    sortOptions() {
      return this.fields.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key }))
    },
  },

  mounted() {
    this.totalRows = this.items.length
    this.getPromotions()
  },

  methods: {
    async dragend() {
      this.isLoading = true
      try {
        await this.$http.post('/promotion/drag', { data: this.items })
        this.getPromotions()
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    switchEnable(id, status) {
      this.$http.post('/promotion/status', { id, status })
        .catch(err => console.log(err))
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },

    getUserslist() {
      this.$http.get('/users/list')
        .then(response => { this.optionsMember = response.data })
        .catch(error => console.log(error))
    },

    async getPromotions() {
      this.isLoading = true
      try {
        const { data } = await this.$http.get('/promotion/index/v2')
        this.onFiltered(data)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    // ✅ แก้ no-param-reassign: ไม่แก้ object ที่วนมาโดยตรง
    onFiltered(rows) {
      // บังคับ status เป็น 0|1 เผื่อบางแถวส่งมาเป็น boolean
      const items = rows.map(r => ({ ...r, status: (r.status ? 1 : 0) }))
      this.items = items
      this.totalRows = items.length
      this.currentPage = 1
    },

    getAdmin(addby, index) {
      this.$http.get(`/admin/show/${addby}`)
        .then(response => {
          this.depositdata[index].addby = response.data.name
        })
        .catch(error => console.log(error))
    },

    // ✅ upsert แบบไม่ชน ESLint และรองรับ API ใหม่โดยไม่เปลี่ยนฟอร์มเดิม
    async upsertPromotion(form) {
      this.isLoading = true
      // ---- normalize flags & arrays ----
      const depfirst = Number(!!Number(form.depfirst))
      const depEveryday = Number(!!Number(form.dep_everyday))
      const selfPick = Number(!!Number(form.self_pick))
      const limit = Number(!!Number(form.limit))
      // eslint-disable-next-line no-nested-ternary
      const canplayArr = Array.isArray(form.cp) ? form.cp : (Array.isArray(form.canplay) ? form.canplay : [])
      const canplayCsv = canplayArr.join(',') || ''
      const amount = limit === 1 ? form.amount || 0 : '' // ไม่จำกัดสิทธิ์ = ไม่ต้องส่ง amount

      const fd = new FormData()
      fd.append('id', form.id ?? '')
      fd.append('name', form.name ?? '')
      fd.append('description', form.description ?? '')
      fd.append('bonus_percent', form.bonus_percent ?? 0)
      fd.append('bonus_amount', form.bonus_amount ?? 0)
      fd.append('min_dep', form.min_dep ?? '')
      fd.append('turn', form.turn ?? '')
      fd.append('min_bonus', form.min_bonus ?? '')
      fd.append('max_bonus', form.max_bonus ?? '')
      fd.append('min_withdraw', form.min_withdraw ?? '')
      fd.append('max_withdraw', form.max_withdraw ?? '')

      // ✅ force numeric flags
      fd.append('depfirst', String(depfirst))
      fd.append('dep_everyday', String(depEveryday))
      fd.append('self_pick', String(selfPick))
      fd.append('limit', String(limit))

      // ✅ canplay/cp → CSV ให้ API ใช้ตัวเดียว
      fd.append('cp', canplayCsv) // สำหรับฝั่งใหม่
      fd.append('canplay', canplayCsv) // เผื่อโค้ดเก่ายังอ่านฟิลด์นี้

      fd.append('img', form.img ?? '')
      fd.append('amount', String(amount))
      fd.append('file', form.file ?? '')

      try {
        await this.$http.post('/promotion/upsert', fd)
        this.getPromotions()
        this.Success('บันทึกโปรโมชั่นสำเร็จ')
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },

    // ✅ แก้ no-param-reassign: clone ก่อน แล้วค่อย set ลง this.form
    edit(form) {
      // eslint-disable-next-line no-param-reassign
      if (form.canplay) form.cp = String(form.canplay).split(',').filter(Boolean).map(n => Number(n))
      // ✅ cast flags สำหรับ UI checkbox
      // eslint-disable-next-line no-param-reassign
      form.depfirst = Number(form.depfirst || 0)
      // eslint-disable-next-line no-param-reassign
      form.dep_everyday = Number(form.dep_everyday || 0)
      // eslint-disable-next-line no-param-reassign
      form.self_pick = Number(form.self_pick || 0)
      // eslint-disable-next-line no-param-reassign
      form.limit = Number(form.limit || 0)
      this.form = { ...form } // clone กัน side-effect เล็กน้อย
      this.editModal = true
    },

    deleteData(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.$http.get(`/promotion/delete/${id}`)
            .then(() => {
              this.getPromotions()
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                customClass: { confirmButton: 'btn btn-success' },
              })
            })
            .catch(error => console.log(error))
        } else {
          this.$swal('Cancelled', 'not been deleted !', 'error')
        }
      })
    },

    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },

    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: { confirmButton: 'btn btn-success' },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: { confirmButton: 'btn btn-primary' },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
  background-color: $product-details-bg;
}
</style>
